import React, { useContext } from "react";
import { Text, Flex, Button } from "@chakra-ui/react";

// Constants
import { SUBSCRIBE_URL } from "constants/constants";
import { CLICK_SUBSCRIBE_LINK } from "constants/analytics";

// Contexts
import { StakeContext } from "providers/StakeProvider";

const SubscribeNow = () => {
  const { track } = useContext(StakeContext);

  return (
    <Flex flexDir="column" gap="0.5rem">
      <Text
        fontSize="14px"
        color="brand.textInactive"
        textAlign={{ base: "left", xl: "center" }}
      >
        Stay updated with our latest news and offers!
      </Text>
      <Button
        variant="outline"
        borderColor="brand.textColor"
        color="brand.textColor"
        _hover={{
          bg: "brand.primary",
          color: "brand.textLight",
        }}
        _dark={{
          _hover: {
            color: "brand.textColor",
            borderColor: "brand.textColor",
          },
        }}
        as="a"
        href={SUBSCRIBE_URL}
        target="_blank"
        onClick={() => track(CLICK_SUBSCRIBE_LINK)}
      >
        <Text fontSize="14px" fontFamily="semi-bold">
          Subscribe now
        </Text>
      </Button>
    </Flex>
  );
};

export default SubscribeNow;
